// https://github.com/umpirsky/country-list
import en from './countries/en'
import nl from './countries/nl'
import fr from './countries/fr'

export default { en, nl, fr }
